module.exports = __webpack_public_path__ + "img/cocktail.a4d7846e.jpg";